import { makeStyles, tokens, shorthands } from '@fluentui/react-components';
import { fontScale } from '@/theme';

export const useDeclineDialogStyles = makeStyles({
  surface: {
    maxWidth: '480px',
    width: '90vw',
    '& button': {
      whiteSpace: 'nowrap',
    },
  },
  textarea: {
    width: '100%',
    minHeight: '80px',
  },
  charCount: {
    display: 'block',
    textAlign: 'right',
    fontSize: fontScale.caption,
    color: tokens.colorNeutralForeground3,
    ...shorthands.margin(tokens.spacingVerticalXXS, '0', '0', '0'),
  },
  errorText: {
    color: tokens.colorPaletteRedForeground1,
    fontSize: fontScale.caption,
    ...shorthands.margin(tokens.spacingVerticalXS, '0', '0', '0'),
  },
});
